import { useMemo } from 'react'
import { Select } from 'antd'
import { useSelector } from 'react-redux'
import { resolveVenueProductUnitPrice } from 'src/utils/priceFunctions'

const { Option, OptGroup } = Select

const SearchableSelect = ({
  value,
  onChange,
  products,
  type = 'sku',
  placeholder = 'Search',
  style = { width: 300 },
}) => {
  const productsFromState = useSelector(state => state.menus.products)
  const productsToUse = products || productsFromState || []

  const groupedOptions = useMemo(() => {
    const groups = {}

    productsToUse.forEach(item => {
      const supplier = item.supplierTitle
      if (!groups[supplier]) groups[supplier] = []
      groups[supplier].push({
        value: item.product[type],
        label: item.product.sku + ' - ' + item.title ?? item.product.title,
        sku: item.product.sku,
        supplier: item.supplierTitle,
        price: resolveVenueProductUnitPrice(item),
        size: item.product.size,
        id: item._id,
        title: item.title || item.product.title || '',
      })
    })
    return groups
  }, [productsToUse, type])

  const handleChange = (value, option) => {
    if (onChange) {
      onChange(value, option)
    }
  }

  return (
    <Select
      showSearch
      value={value}
      placeholder={placeholder}
      optionFilterProp='children'
      onChange={handleChange}
      style={style}
      dropdownStyle={{ minWidth: '320px', padding: '8px' }}
      listHeight={400}
      optionHeight={50}
      filterOption={(input, option) => {
        const { children, label } = option?.props || {}
        const text = typeof children === 'string' ? children : label
        if (!text) return false

        return (
          String(text).toLowerCase().includes(input.toLowerCase()) ||
          (option.props?.['data-supplier'] || '')
            .toLowerCase()
            .includes(input.toLowerCase())
        )
      }}
    >
      {Object.entries(groupedOptions).map(([supplier, options]) => (
        <OptGroup key={supplier} label={supplier}>
          {options.map(option => (
            <Option
              key={option.id}
              value={option.id}
              label={option.label}
              data-supplier={option.supplier}
            >
              {type === 'sku' ? (
                option.label
              ) : (
                <div
                  style={{
                    padding: '8px',
                    borderRadius: '5px',
                    background: '#f8f8f8',
                    marginBottom: '5px',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
                    width: '100%',
                  }}
                >
                  <div
                    style={{
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                    }}
                  >
                    <strong>Product:</strong> {option.title} <br />
                    <strong>Supplier:</strong> {option.supplier} <br />
                    <strong>Price:</strong> £{option.price} <br />
                    <strong>Size:</strong> {option.size}
                  </div>
                </div>
              )}
            </Option>
          ))}
        </OptGroup>
      ))}
    </Select>
  )
}

export default SearchableSelect
